import React, { useEffect, useState } from 'react';

const pesos = (n) => `$${Number(n || 0).toLocaleString('es-MX', { maximumFractionDigits: 0 })}`;

/**
 * La pantalla que aparece justo después de que la tienda escanea el QR
 * (`EQUIVALENCIA_BENEFICIO` de los mockups).
 *
 * Es el momento de mayor emoción del producto: el cliente acaba de pagar menos
 * y todavía está en la caja. Por eso ocupa la pantalla completa, sin barra de
 * navegación ni botones que compitan — se sale tocando en cualquier lado, tal
 * como pidió Iván.
 *
 * Las dos equivalencias se alternan solas cada 3.5 segundos: la de acceso
 * («2 años de acceso», que se calcula) y la de una cosa concreta («un vuelo a
 * Cancún», que carga el admin). Si solo hay una, no rota.
 */
export function CanjeFelicidades({ canje, onCerrar }) {
  const [alterna, setAlterna] = useState(0);

  const acceso = canje?.equivalence?.access ?? null;
  const cosa = canje?.equivalence?.thing ?? null;
  const opciones = [acceso, cosa].filter(Boolean);

  useEffect(() => {
    if (opciones.length < 2) return undefined;
    const t = setInterval(() => setAlterna((v) => (v + 1) % opciones.length), 3500);
    return () => clearInterval(t);
  }, [opciones.length]);

  if (!canje) return null;

  const actual = opciones[alterna % Math.max(opciones.length, 1)] ?? null;

  const enEspecie = canje?.modo === 'en_especie' && canje?.etiqueta;


  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onCerrar}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onCerrar?.()}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 60,
        background: 'linear-gradient(160deg, #F73E48 0%, #F52B16 45%, #FA759F 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 28px',
        cursor: 'pointer',
        animation: 'mp-fade-in .35s ease',
      }}
    >
      <h1
        className="font-display"
        style={{
          color: '#fff',
          fontSize: 'clamp(38px, 12vw, 54px)',
          fontWeight: 700,
          letterSpacing: '-0.03em',
          margin: 0,
          textAlign: 'center',
          lineHeight: 1.05,
        }}
      >
        ¡Felicidades!
      </h1>

      {/*
        Un beneficio en especie —unos meses sin intereses— no se celebra con una
        cifra: «te acabas de ahorrar $0» sería mentira y quitaría mérito a lo que
        sí se llevó. Se dice qué fue.
      */}
      <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: 15, margin: '10px 0 0' }}>
        {enEspecie ? 'acabas de usar tu beneficio' : 'te acabas de ahorrar'}
      </p>

      {/* Sobre fondo rojo el acento va de blanco a rosa (BRAND.md §1). */}
      <div
        className="font-display"
        style={{
          fontSize: enEspecie ? 'clamp(30px, 9vw, 46px)' : 'clamp(64px, 22vw, 108px)',
          fontWeight: 700,
          letterSpacing: '-0.04em',
          lineHeight: enEspecie ? 1.15 : 1,
          margin: '18px 0 26px',
          backgroundImage: 'linear-gradient(100deg, #FFFFFF, #F794B4)',
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          color: 'transparent',
        }}
      >
        {enEspecie ? canje.etiqueta : pesos(canje.saved)}
      </div>

      {actual && (
        <div
          style={{
            background: '#fff',
            borderRadius: 26,
            padding: '26px 22px',
            width: '100%',
            maxWidth: 360,
            textAlign: 'center',
            boxShadow: '0 18px 40px -12px rgba(0,0,0,0.25)',
          }}
        >
          <div className="font-display" style={{ fontSize: 24, fontWeight: 700, color: '#0E0E10' }}>
            Equivale a
          </div>
          <div
            style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: '#6E6E77',
              margin: '8px 0 10px',
            }}
          >
            {/* «de membresía» → «de acceso»: Iván pidió sacar esa palabra del
                lado del usuario (13-ago-2026). Lo que se vende es acceso. */}
            {actual === acceso ? 'de acceso a vondi' : 'lo que cuesta'}
          </div>
          <div
            className="font-display"
            style={{
              fontSize: 24,
              fontWeight: 700,
              letterSpacing: '-0.01em',
              backgroundImage: 'linear-gradient(100deg, #FA4D0A, #F73E48)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
            }}
          >
            {actual.icon ? `${actual.icon} ` : ''}
            {actual.label}
          </div>

          {opciones.length > 1 && (
            <div style={{ display: 'flex', gap: 5, justifyContent: 'center', marginTop: 16 }}>
              {opciones.map((o, i) => (
                <span
                  key={o.label}
                  style={{
                    width: i === alterna ? 16 : 5,
                    height: 5,
                    borderRadius: 9999,
                    background: i === alterna ? '#F73E48' : '#E7E7EC',
                    transition: 'width .25s ease',
                  }}
                />
              ))}
            </div>
          )}
        </div>
      )}

      <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 12.5, marginTop: 30 }}>
        Toca en cualquier lugar para continuar
      </p>
    </div>
  );
}

export default CanjeFelicidades;
